import React, { useState } from 'react';
import { Modal, Input, Button, notification } from 'antd';
import api from '../api/axios';

const { TextArea } = Input;

const SendMessage = ({ senderId, receiverId, isVisible, onClose }) => {
    const [message, setMessage] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState('');

    const handleSendMessage = async () => {
        if (!message.trim()) {
            setError('Please enter a message.');
            return;
        }

        setError('');
        setIsSending(true);
        try {
            const payload = {
                sender_id: senderId,
                receiver_id: receiverId,
                message,
            };

            const response = await api.post('/messages/send', payload);

            if (response.data.status === 'success') {
                notification.success({
                    message: 'Message Sent',
                    description: 'Your message has been sent successfully.',
                });
                setMessage('');
                onClose();
            } else {
                notification.error({
                    message: 'Failed to Send Message',
                    description: 'Something went wrong. Please try again.',
                });
            }
        } catch (error) {
            console.error('Error sending message:', error);
            notification.error({
                message: 'Failed to Send Message',
                description: 'Something went wrong. Please try again.',
            });
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Modal
            title="Send Message"
            open={isVisible}
            onCancel={onClose}
            maskClosable={false}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="send" type="primary" loading={isSending} onClick={handleSendMessage}>
                    Send
                </Button>,
            ]}
        >
            <TextArea
                rows={8}
                placeholder="Type your message here..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
            />
            {error && (
                <div style={{ color: 'red', marginTop: '8px' }}>
                    {error}
                </div>
            )}
        </Modal>
    );
};

export default SendMessage;